import { AuthenticatedComponent } from '../auth/keycloak';
import { BuyCurrency } from '../component/profileComponents/BuyCurrency';
import { ProfileBanner } from '../component/profileComponents/ProfileBanner';
import { VaultCurrency } from '../component/profileComponents/VaultCurrency';

export const ProfileVault: AuthenticatedComponent = ({ keycloak }) => {
    return (
        <>
            <ProfileBanner />
            <VaultCurrency keycloak={keycloak} />
            <BuyCurrency keycloak={keycloak} onPurchase={() => {}} />
        </>
    );
};
